export default __webpack_public_path__ + "static/media/illegal-moves.c390bf78.md";